import React, { useEffect } from "react"; 
import { Typography, Descriptions, Button, Image, Table } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import Pageloader from "../../components/loader";
import { useNavigate, useParams } from "react-router-dom";
import * as actionPage from "../../redux/actions/unRegisterRider.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { Title } = Typography;
const pageName = "Un Register Rider";
const pageLink = "un-register/rider";

const UnRegisterRidersView = (props) => {
  const params = useParams();
  const { riderId } = params;
  const navigate = useNavigate();

  useEffect(() => {
    if (riderId){ForSingleDataEdit()}
  }, [riderId])
  const ForSingleDataEdit = async () => {
    try {
      props.actionPage.singleAction(riderId);
    } catch (e) {}
  }

  const columns = [
    {
      title: 'Similarity',
      dataIndex: 'Similarity',
      render: (value) => ( value.toFixed(2) || "-" )
      // (Math.round(num * 100) / 100).toFixed(2);
    },
    {
      title: 'Rider ID',
      dataIndex: 'riderImage',
      render: (value) => ( value?.display_id || "-" )
    },
    {
      title: 'Rider Image',
      dataIndex: 'riderImage',
      render: (value) => ( value?.profileImage ? <Image alt="Profile Image" src={value?.profileImage||''} /> : "-" )
    },
  ]

  return (
    <div className="page-content">
      <div className="page-content-header">
        <Title level={2}>{`${pageName} View`}</Title>
        <Button onClick={() => navigate(`/${pageLink}`)}><RollbackOutlined /></Button>
      </div>
      <div className="p-content">
        {props?.pageLoader ? <Pageloader/>:<>
          <Title level={2} className="mb-15">Name: {props?.pageFindOne?.fullName||"-"}</Title>
          {/* <Descriptions style={{ marginBottom: "35px" }} className="listLabelBold">
            <Descriptions.Item label="Rider Profile Image" span={3}>
                <Image alt="Profile Image" src={props?.pageFindOne?.profileImage||''} /> 
            </Descriptions.Item>
          </Descriptions> */}
          <Title level={5}>{`Rider Profile Image`}</Title>
          <Image className="mb-20" alt="Profile Image" src={props?.pageFindOne?.profileImage||''} /> 
          <Table
            dataSource={props?.pageFindOne?.face_index_response}
            columns={columns}
            pagination={false}
          ></Table>
        </>} 
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    pageFindOne: state.UnRegisterRiderReducer.initialSingle,
    pageLoader: state.UnRegisterRiderReducer.initialLoading,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    actionPage: bindActionCreators(actionPage, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UnRegisterRidersView);
